import React, {
  CSSProperties,
  HTMLAttributes,
  useImperativeHandle,
  useRef,
} from 'react';
import classNames from 'classnames';

import Loader from '../Loader/Loader';
import { ButtonType } from './types';
import './Button.scss';

export interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
  applyBranding?: boolean;
  btnStyle?: string;
  buttonType: ButtonType;
  contextStyle?: CSSProperties;
  loading?: boolean;
  disabled?: boolean;
}

/**
 * This is legacy from the conversion from a Class
 * @todo remove forwardRef and buttonRef
 */
interface FocusPublicInterface extends HTMLButtonElement {
  focus(): void;
}

/**
 * Primary UI component for user interaction
 */
export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      applyBranding = true,
      btnStyle,
      buttonType,
      children,
      disabled,
      className = '',
      contextStyle,
      loading = false,
      ...props
    },
    ref
  ) => {
    const buttonRef = useRef<HTMLButtonElement>(null);

    useImperativeHandle(
      ref,
      () =>
        ({
          focus() {
            buttonRef.current?.focus();
          },
        } as FocusPublicInterface)
    );

    const classes = classNames(
      btnStyle,
      {
        'btn btn-trp-primary': buttonType === ButtonType.PRIMARY,
        'btn btn-trp-primary btn-full-width-mobile':
          buttonType === ButtonType.PRIMARY_MOBILE,
        'btn btn-trp-primary-slim': buttonType === ButtonType.PRIMARY_SLIM,
        'btn btn-trp-primary-large': buttonType === ButtonType.PRIMARY_LARGE,
        'btn btn-trp-secondary': buttonType === ButtonType.SECONDARY,
        'btn btn-trp-secondary-slim': buttonType === ButtonType.SECONDARY_SLIM,
        'btn btn-trp-secondary-large':
          buttonType === ButtonType.SECONDARY_LARGE,
        'btn btn-trp-callout': buttonType === ButtonType.CALLOUT,
        'btn btn-trp-callout-slim': buttonType === ButtonType.CALLOUT_SLIM,
        'btn btn-trp-callout-large': buttonType === ButtonType.CALLOUT_LARGE,
        'btn btn-step2': buttonType === ButtonType.STEP_2,
        'btn btn-trp-secondary btn-trp-ghost-white':
          buttonType === ButtonType.SECONDARY_GHOST,
      },
      className,
      {
        'college-branded-primary-button':
          applyBranding &&
          (buttonType?.startsWith('primary') || btnStyle?.includes('primary')),
      }
    );

    return (
      <button
        ref={buttonRef}
        className={classes}
        disabled={disabled}
        style={contextStyle}
        {...props}
      >
        <Loader isVisible={loading} />
        {!loading && children}
      </button>
    );
  }
);
// export Button as default for legacy calls
export default Button;
